/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StaffTagContainer_settings = {
    readonly staff: {
        readonly staffLabel: string;
        readonly adminLabel: string;
        readonly moderatorLabel: string;
    };
    readonly " $refType": "StaffTagContainer_settings";
};
export type StaffTagContainer_settings$data = StaffTagContainer_settings;
export type StaffTagContainer_settings$key = {
    readonly " $data"?: StaffTagContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"StaffTagContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StaffTagContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "StaffConfiguration",
            "kind": "LinkedField",
            "name": "staff",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "staffLabel",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminLabel",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderatorLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '98d9dd0066ce56f975d42dca50eebb3c';
export default node;
